/**
 * @module app.bdc.reports.checklistMaterielCtrl
 *
 */
define(['angular'], function(angular) {


    function ChecklistMaterielCtrl() {
        var self = {};

        return self;
    }

    ChecklistMaterielCtrl.$inject = [];

    angular
        .module('app.bdc.reports.checklistMaterielCtrl', [])
        .controller('ChecklistMaterielCtrl', ChecklistMaterielCtrl);
});
